<div class="reviews-container">
    <!-- Header -->
    <div class="reviews-header">
        <h2 class="section-title ">{{ 'reviews.title' | translate }}</h2>

    </div>

    <!-- Search -->
    <div class="search-wrapper">
        <input type="text" class="search-input" [placeholder]="'reviews.searchPlaceholder' | translate" [(ngModel)]="searchQuery"
            (input)="onSearch()" />
        <span class="search-icon pi pi-search"></span>
    </div>

    <!-- Tabs + Filters -->
    <div class="tabs-row">
        <div class="tabs">
            <span class="tab-item" [class.active]="activeTab === 'Pending'" (click)="setTab('Pending')">{{ 'reviews.pending' | translate }}</span>
            <span class="tab-item" [class.active]="activeTab === 'Approved'"
                (click)="setTab('Approved')">{{ 'reviews.approved' | translate }}</span>
            <span class="tab-item" [class.active]="activeTab === 'Declined'"
                (click)="setTab('Declined')">{{ 'reviews.declined' | translate }}</span>
        </div>
   
    </div>

    <!-- Cards -->
    <!-- replace the cards-list section -->
    <div *ngIf="isLoading" class="empty-state">{{ 'reviews.loading' | translate }}</div>

    <div class="cards-list" *ngIf="!isLoading">
        <app-review-card *ngFor="let review of filteredReviews" [review]="review" (onApprove)="approveReview($event)"
            (onDecline)="declineReview($event)" (onDelete)="deleteReview($event)" (onSaveReply)="saveReply($event)"
            (onDeleteReply)="deleteReply($event)" (onToggleHide)="toggleHide($event)">
        </app-review-card>

        <div *ngIf="filteredReviews.length === 0" class="empty-state">
            {{ 'reviews.noReviews' | translate }}
        </div>
    </div>
</div>